/**
 * Тот же расчёт оффера, что делает бандл ndd-widget (widget-pvz.dostavka.yandex.net).
 * Позволяет получить стоимость доставки до ПВЗ по id пункта без монтирования карты.
 */
const YANDEX_OFFERS_CREATE_URL =
    'https://widget-pvz.dostavka.yandex.net/api/b2b/platform/offers/create';

function parseRubValue(v) {
    if (typeof v === 'number' && !Number.isNaN(v)) {
        return v;
    }
    if (typeof v === 'string') {
        const n = parseFloat(String(v).replace(/[^\d.,-]/g, '').replace(',', '.'));
        if (!Number.isNaN(n)) {
            return n;
        }
    }
    return null;
}

/**
 * Тело запроса совпадает с buildOffersCreateBody в widget.js (Landpro / Яндекс НДД).
 */
function buildOffersCreateBody(destinationPointId, sourcePlatformStationId, physicalDims) {
    const { dx, dy, dz, weightGross } = physicalDims;
    return {
        billing_info: { payment_method: 'already_paid' },
        destination: {
            type: 'platform_station',
            platform_station: { platform_id: String(destinationPointId) },
        },
        info: { operator_request_id: '1' },
        items: [
            {
                article: '1',
                billing_details: { assessed_unit_price: 1, unit_price: 1 },
                count: 1,
                name: '1',
                place_barcode: '1',
            },
        ],
        last_mile_policy: 'self_pickup',
        places: [
            {
                barcode: '1',
                physical_dims: {
                    dx,
                    dy,
                    dz,
                    weight_gross: weightGross,
                },
            },
        ],
        recipient_info: {
            email: 'dummy@inbox.ru',
            first_name: 'Dummy',
            phone: '+79999999999',
        },
        source: {
            platform_station: { platform_id: String(sourcePlatformStationId) },
        },
    };
}

/**
 * @param {{
 *   sourcePlatformStationId: string,
 *   destinationPointId: string,
 *   weightGrossG?: number,
 *   dimMm?: number,
 *   signal?: AbortSignal
 * }} p
 * @returns {Promise<{ pricingRub: number|null, errorMessage: string|null }>}
 */
export async function fetchYandexPvzOfferPricingRub(p) {
    const {
        sourcePlatformStationId,
        destinationPointId,
        weightGrossG = 3000,
        dimMm = 10,
        signal,
    } = p;
    const src = String(sourcePlatformStationId || '').trim();
    const dst = String(destinationPointId || '').trim();
    if (!src || !dst) {
        return { pricingRub: null, errorMessage: 'Нет станции отгрузки или id пункта' };
    }
    const body = buildOffersCreateBody(dst, src, {
        dx: dimMm,
        dy: dimMm,
        dz: dimMm,
        weightGross: weightGrossG,
    });
    let res;
    try {
        res = await fetch(YANDEX_OFFERS_CREATE_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
            signal,
        });
    } catch (e) {
        if (e?.name === 'AbortError') {
            return { pricingRub: null, errorMessage: null };
        }
        return { pricingRub: null, errorMessage: e?.message || 'Сеть' };
    }
    let data;
    try {
        data = await res.json();
    } catch {
        return { pricingRub: null, errorMessage: 'Некорректный ответ' };
    }
    if (!res.ok) {
        return { pricingRub: null, errorMessage: data?.message || `HTTP ${res.status}` };
    }
    const offer = data?.offers?.[0];
    const raw = offer?.offer_details?.pricing_total;
    const pricingRub = parseRubValue(raw);
    if (pricingRub != null) {
        return { pricingRub, errorMessage: null };
    }
    return {
        pricingRub: null,
        errorMessage: 'В ответе нет стоимости доставки',
    };
}
